import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import scrollbars from '@helpers/scrollbars';
import { paragraphSmall } from '@helpers/typography';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  &[data-background='beige'] {
    background-color: ${brand.beige};

    &[data-spacing-below='true'] {
      padding-bottom: var(--sectionSpacing);
    }
  }

  &[data-background='white'] {
    background-color: ${brand.white};

    &[data-spacing-below='true'] {
      margin-bottom: var(--sectionSpacing);
    }
  }

  @media print {
    display: none;
  }
`;
const List = styled.ul `
  overflow: auto;
  white-space: nowrap;

  ${scrollbars};
`;
const Item = styled.li `
  ${paragraphSmall};

  line-height: ${fluid(52, 52)};
  display: inline-block;
  margin: 0 8px 0 0;

  &::after {
    content: '\\003E';
    margin-left: 8px;
  }

  &:last-child {
    &::after {
      display: none;
    }
  }
`;
const ItemLink = styled.a `
  color: ${brand.black};
  text-decoration: none;
  text-underline-position: under;

  &[aria-current='location'],
  &:hover {
    text-decoration: underline;
  }
`;
const BreadcrumbStyles = {
    Container,
    List,
    Item,
    ItemLink,
};
export default BreadcrumbStyles;
